export default {"src":"/_next/static/media/notification-lazo-one-drawer-logo.cd7395d1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};